import React, { useEffect, useState } from 'react';

import { AdminPage } from './AdminPage';
import { resetBenefitsViewedStatus } from '../../../api/benefits/benefits';
import { getLogger } from '../../../utils/logger/logger';
import { getUserInteractions } from '../../../api/userInteractions/userInteractions';

export const AdminPageContainer = () => {
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      await getUserInteractions();
    })();
  }, []);

  const onResetNavigationDots = async () => {
    setIsRequestInProgress(true);
    try {
      await resetBenefitsViewedStatus();
      setIsRequestInProgress(false);
    } catch (error) {
      getLogger('AdminPageContainer resetBenefitsViewedStatus').error({ error });
      setError(error);
    }
  };

  if (error) throw error;

  return <AdminPage isRequestInProgress={isRequestInProgress} onResetNavigationDots={onResetNavigationDots} />;
};
